import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import router from './router.js';
import { website } from '@/config.js'
import App from './App.vue'
import './styles/common.scss'
import '@/utils/es6'
import '@/mock/'
import store from './store/index.js'
import VueFullscreen from 'vue-fullscreen'
import i18n from './lang/index.js';
import './styles/yzfcFont.scss'
//导入主题文件
import '@/theme/index.js'
import tool from "./utils/tool.js";
Vue.use(tool);
Vue.config.productionTip = false
window.axios = axios;
document.title = website.title
Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)});
Vue.use(VueFullscreen)
Vue.prototype.$website = website;
Vue.use(dataV)
Vue.use(window.AVUE, {
  size: 'mini',
  tableSize: 'mini',
  calcHeight: 50,
  i18n: (key, value) => i18n.t(key, value)
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
import util from '/src/config/open'
Vue.prototype.$util = util;
